<template>
  <div>
    <b-row>
      <b-col cols="12" class="mb-2">
        <span class="text-muted text-capitalize">{{ $t('patrol_logs.unit_commander.no_filters') }}</span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
  },
}
</script>
